<ng-container *ngIf="accountMenu$ | async as accountMenu">
    <div class="account-menu {{ documentDirection }}">
        <div class="account">
            <div class="user-profile-pic" *ngIf="userPicture">
                <serviceos-web-avatar routerLink="/account-settings"></serviceos-web-avatar>
            </div>
            <div *ngIf="userNames">
                <div class="user-names">
                    <serviceos-web-names></serviceos-web-names>
                </div>
                <div class="user-type" *ngIf="isMembershipEnable">
                    <serviceos-web-member>
                    </serviceos-web-member>
                </div>
            </div>
        </div>

        <div class="menu-toggle-holder">
            <div class="notification" *ngIf="toggleNotification"></div>
            <div
                class="menu-toggle"
                (mouseenter)="toggleMenuClick(true)"
                [@rotate]="toggleMenu"
            >
                <serviceos-ng-system-icon
                    [icon]="'arrow-down'"
                ></serviceos-ng-system-icon>
            </div>
        </div>

        <div
            class="menu-dropdown"
            *ngIf="toggleMenu"
            [@collapseOnLeave]
            [@menu-wrap-enter]
        >
            <div
                class="arrow"
                [ngClass]="{ color: colorArrow }"
                *ngIf="toggleMenu"
                [@fadeInOnEnter]
            ></div>

            <div class="invisible-spacer"></div>

            <div class="menu" *ngIf="toggleMenu" [@expandOnEnter]>
                <ng-container
                    *ngIf="accountMenu.user; else notLoginTemplate"
                >
                    <serviceos-ng-menu>
                        <ng-container *ngFor="let menuItem of navigation$ | async">
                            <serviceos-ng-menu-item
                                [routerLink]="menuItem.path"
                                (click)="menuItem && menuItem.action && menuItem.action === 'logout' && logout()"
                                [routerLinkActive]="'active'"
                                class="item-{{ menuItem.name }}"
                                #menuItems
                            >
                                <span *ngIf="!menuItem.icon_url; else iconImage">
                                    <serviceos-ng-system-icon
                                        [icon]="menuItem.icon"
                                    ></serviceos-ng-system-icon>
                                </span>
                                <ng-template #iconImage>
                                    <span class="icon-image-holder" [ngStyle]="{'background': 'url(' + menuItem.icon_url + ') 0 50% no-repeat' }"></span>
                                </ng-template>

                                {{ menuItem.title }}

                                <ng-container *ngIf="menuItem.tag">
                                    <serviceos-ng-tag [tag]="menuItem.tag">{{
                                        menuItem.count ? menuItem.count : ''
                                    }}</serviceos-ng-tag>
                                </ng-container>
                            </serviceos-ng-menu-item>
                        </ng-container>
                        
                        <ng-container *ngIf="!isLogoutItemAvailable">
                            <serviceos-ng-menu-item (click)="logout()">
                                <serviceos-ng-system-icon
                                    [icon]="'logout'"
                                ></serviceos-ng-system-icon>
                                    <ng-container *ngIf="moduleCustomerTexts$ | async as moduleCustomerTexts">
                                        {{ moduleCustomerTexts.logout }}
                                    </ng-container>
                            </serviceos-ng-menu-item>
                        </ng-container>
                        
                    </serviceos-ng-menu>
                </ng-container>
                <ng-template #notLoginTemplate>
                    <div class="not-login-screen">
                        <span>Already have an account?</span>
                        <serviceos-ng-button
                            (click)="fireAction('login-button')"
                            [isAutoWidth]="true"
                        >
                            Log in</serviceos-ng-button
                        >

                        <div class="register-option">
                            <span>No Account?</span
                            ><serviceos-ng-link
                                size="small"
                                font_weight="semi-bold"
                                (click)="fireAction('register-button')"
                            >
                                Start hare</serviceos-ng-link
                            >
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</ng-container>

<!-- <div>
    <pre>{{ navigation$ | async | json }}</pre>
    <pre>{{ account$ | async | json }}</pre>
    
</div> -->
